/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FitnessIcon
 */
export default class FitnessIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M6.5 3A2.5 2.5 0 019 5.5V9h6V5.5A2.5 2.5 0 0117.5 3h1A2.5 2.5 0 0121 5.5V8a3 3 0 012.995 2.824L24 11v2a3 3 0 01-2.824 2.995L21 16v2.5a2.5 2.5 0 01-2.5 2.5h-1a2.5 2.5 0 01-2.5-2.5V15H9v3.5A2.5 2.5 0 016.5 21h-1A2.5 2.5 0 013 18.5V16a3 3 0 01-3-3v-2a3 3 0 013-3V5.5A2.5 2.5 0 015.5 3h1zm12 2h-1a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zm-12 0h-1a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zM21 10v4a1 1 0 00.993-.883L22 13v-2a1 1 0 00-.883-.993L21 10zM2 11v2a1 1 0 001 1v-4a1 1 0 00-1 1zm13 0H9v2h6v-2z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

